import { Pipe, PipeTransform } from "@angular/core";
import { PlanningInformationSubtype } from "../services/planning.service";

@Pipe({ name: "instructionSubtypeName" })
export class ExperimentDesignInstructionSubtypeNamePipe implements PipeTransform {
  private dictionary: { [id: number] : string } = {
    1: "Substrate",
    2: "Irrigation",
    3: "Fertigation",
    4: "Lighting",
    5: "Temperature",
    6: "Humidity",
    7: "Pesticide"
  };

  transform(value: PlanningInformationSubtype) {
    return this.dictionary[value];
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/pipes/design-instruction-subtype.pipe.ts